// https://observablehq.com/@berhardki/die-suche-nach-den-dunkelflauten@14213
export default function define(runtime, observer) {
  const main = runtime.module();
  const fileAttachments = new Map([
  ["bootstrap.bundle.min.js",require("./files/6cf242ec4814aa1a5fc921cc2716bc2dec7e0a2a7e9461c38cd7c0b8e7ddd1a12a3ad5bf149de8883070dd679e0188e495b9ffabd4b06d05809cb06c1a7cbff8").default],
  ["bg.jpg",require("./files/d78591527d28337968d24fb0dcb6a41ab9b07568da9d939c5919cc3837020a674856a41b627a326c936cb0f0b95846d2638a6ddabb0e253ac5ab5a50d7e88f7b").default],
  ["Aller_Rg.ttf",require("./files/3a5e627d2f4d5dba36494fdb55f842eb546624689fda84f6e9bba634d3261521a2e09f6f45f1c8ebe5675ca7d68a9a45b4c17767da927fde2a182525b644b711").default],
  ["bootstrap.min.css",require("./files/80206945fc27e5aee59fd4a195086df069c07913f8a998613025de3808d29c0a8477fc07c8ed314c28b499fbf0a83a9485c53d84e29141440bcef839ee731e66").default],
  ["data_for_history_analysis@1.csv",require("./files/52667c693f88f48d671752efe6a7a1ddf69811c112df68dd449d9d6ad01a2aa62f2433507b0369cb4185238ca8a3d3f360cb1c280ca9b0fda0f272b8e0a5240f").default]]);
  main.builtin("FileAttachment", runtime.fileAttachments(name => fileAttachments.get(name)));
  main.variable(observer()).define(["html"], function(html){return(
html`<h1>Die Suche nach den Dunkelflauten</h1>`
)});
  main.variable(observer("einleitung")).define("einleitung", ["html","FileAttachment"], async function(html,FileAttachment){return(
html`
<link href="${await FileAttachment('bootstrap.min.css').url()}" rel="stylesheet" integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3" crossorigin="anonymous">
Die Energiewende ist eine Revolution der Stromversorgung. Künftig werden Wind und Sonne den Takt der Stromerzeugung vorgeben. Das bedeutet: Mal wird der Stromertrag über dem Verbrauch liegen, mal darunter; die Kunst wird darin bestehen, Verbrauch und Erzeugung auszupendeln.
Das Meisterwerk der Energiewende wird jedoch sein, die sogenannte Dunkelflaute zu beherrschen: Stunden oder gar Tage, in denen kaum noch Wind weht. Denn dann sackt auch der Stromertrag dramatisch ab. Um solche Dunkelflauten zu finden, haben wir mit dem SMC Lab ein digitales Tool entwickelt, den Dunkelflauten-Guide. Die Datenbasis – die Stromerzeugungsdaten seit 2015 – und die möglichen Filter haben wir im Fact Sheet <a href= "https://www.sciencemediacenter.de/fileadmin/user_upload/Fact_Sheets_PDF/Preppen-fuer-die-Dunkelflaute-I_SMC_Fact-Sheet_24112021.pdf" target="_blank"> Auf der Suche nach der Dunkelflaute </a> beschrieben . <br>
<br>
Mit dem Dunkelflauten-Guide lassen sich anhand der Stromerzeugungsdaten  interaktiv kritische  Phasen in der Periode zwischen 2015 und 2021  aufspüren, in denen über Stunden oder Tage kaum noch Wind wehte.  Auf solche Phasen muss eine Stromversorgung auf der Basis von Windkraft- und Photovoltaikanlagen besonders vorbereitet werden.
Mit welchen Techniken das gehen kann, können Sie in dem Model-Driven Fact Sheet <a href="https://wie-gelingt-die-energiewende.smc.page" target="_blank"> Wie gelingt die Energiewende? </a> erkunden.
`
)});
  main.variable(observer("daten")).define("daten", ["html"], function(html){return(
html`
<details>
<summary><b>Unsere Datengrundlage</b></summary>

Die Grundlage dafür bilden die tatsächliche erzeugten Strommengen für die öffentliche Stromversorgung in Deutschland von 2015 bis heute. Diese werden für die Öffentlichkeit frei zugänglich von zwei verschiedenen Institutionen zur Verfügung gestellt: <ul>
  <li>von der Bundesnetzagentur über ihr Portal <a href="https://www.smard.de/home" target="_blank">SMARD</a></li>
  <li>vom Fraunhofer Institut für Solare Energietechnik ISE über ihr Portal <a href="https://energy-charts.info/index.html?l=de&c=DE" target="_blank">Energy-Charts</a></li>
</ul> 
Beide Portale stützen sich auf die Liste der Kraftwerke und EE-Anlagen in Deutschland <a href="https://www.bundesnetzagentur.de/DE/Sachgebiete/ElektrizitaetundGas/Unternehmen_Institutionen/DatenaustauschundMonitoring/Marktstammdatenregister/MaStR_node.html" target="_blank">Liste der Kraftwerke und EE-Anlagen in Deutschland</a> sowie die über die Strombörse EEX gehandelten <a href="https://www.eex.com/de/marktdaten/strom" target="_blank">Strommengen</a> und bieten eine stundengenaue Dokumentation der tatsächlichen Stromerzeugung. 

Die Datensätze unterscheiden sich geringfügig voneinander. So berechnen zum Beispiel das Fraunhofer ISE auch die Einspeisung von Kraftwerken oder Anlagen kleiner als 50MW – diese werden von der EEx nicht erfasst. Zudem unterscheiden sich die beiden Datensätze in den Zeitpunkten, zu dem sie neu installierte EE-Anlagen aufführen. Prinzipiell kann unser Tool beide Datensätze einsetzen, so dass ein Vergleich möglich ist. Im ersten Schritt haben wir uns dabei auf die SMARD-Daten konzentriert, die Energy-Charts-Werte werden wir in einem späteren Update einpflegen. <br><br> 

Für die Auswertung haben wir den Datensatz etwas aufgearbeitet. So berechnen wir zum Beispiel die in unregelmäßigen Abständen durch Inbetriebnahme neuer Windkraft- und PV-Anlagen steigende installierte Leistung dadurch, dass wir für ein Jahr den Durchschnitt aus der installierten Leistung am Jahresanfang und am Jahresende bilden. Dadurch liegt prinzipiell die Leistung in der ersten Jahreshälfte etwas zu hoch, in der zweiten etwas zu niedrig. 
<br>
<br>
</details>
`
)});
  main.variable(observer("dunkelflautensuche")).define("dunkelflautensuche", ["html"], function(html){return(
html `<h3> Wann gab es von 2015 bis 2021 Dunkelflauten?<h3>`
)});
  main.variable(observer()).define(["html"], function(html){return(
html `Hier können Sie in den Stromerzeugungsdaten der Jahre 2015 bis 2021 nach Ereignissen suchen, in denen die Erzeugung von Strom aus Windkraft- und PV-Anlagen – oder aus allen erneuerbaren Quellen – zwei Bedingungen erfüllt: <ul> <li> Ein von Ihnen gewählter Maximalwert für die Stromerzeugung wird nicht überschritten <li> und zwar an einer von Ihnen gewählte  Mindestdauer an Tagen.</ul> 
 `
)});
  main.variable(observer()).define(["html"], function(html){return(
html`
<details>
<summary><b>Informationen zu den voreingestellten Werten</b></summary>
Wir haben diese Parameter gewählt, weil wir gezielt nach Dunkelflauten gesucht haben. Dabei kommt es drauf an, den geringstmöglichen Anteil von Windkraft- und PV-Anlagen am Stromverbrauch, der möglicherweise über Tage anhält, zu finden. In mehreren Schritten konnten wir feststellen, dass eine sinnvolle Einstellung für unsere Frage bei einem Anteil von maximal 30 Prozent und einer Dauer von 168 Stunden liegt
</details>`
)});
  main.variable(observer()).define(["viewof filter_criterium","viewof absolute_or_relative","htl"], function($0,$1,htl){return(
htl.html`<div class="row">
    <div class="col-12 col-sm-6">
     ${$0}
      <details class="small">
<summary>Informationen zu den Filterkriterien</summary>
Hier geben Sie vor, ob Sie die Daten bezüglich des Anteils am Strombedarf filtern möchten oder bezüglich der Auslastung der Anlagen, also nach dem Anteil an Leistung pro installierter Leistungseinheit, d.h. der maximal möglichen Leistung. 
<br>
Bezüglich des Anteils am Strombedarf können Sie wählen, ob Sie in den Daten nur nach Strom aus PV-und Windanlagen oder aus allen erneuerbaren Quellen, also auch Wasser- und Biomassekraftwerken, sowie Erdwärmem, Deponiegas, Klärgas und Grubengas, suchen möchten. Für die Frage nach den Dunkelflauten ist die Suche allein nach den wetterabhängigen Solar- und Windkraftwerken zunächst sinnvoller, wenn Sie aber sehen wollen, wie viel fossile Kraftwerke laufen mussten, kann die zweite Auswahl sinnvoll sein. 
<br>
Bezüglich der intallierten Leistung können Sie Windkraft- und PV-Analgen gemeinsam oder getrennt betrachten. Bei den Windkraftanlagen sind Onshore und Offshore Anlagen zusammengefasst. 
      </details>
    </div>
    <div class="col-12 col-sm-6">
${$1}
      <details class="small">
<summary>Informationen zu den Bezugsgrößen</summary>
Hier geben Sie vor, ob Sie die Daten nach dem tatsächlichen Anteil bzw. der tatsächlichen Auslastung filtern möchten (absolut), oder bezüglich der Durchschnittswerte der Jahre 2015 bis 2020 (bezüglich Durchschnittswerte). Ein Beispiel: Filterkriterium: "Anteil Wind und PV an Bedarf", Bezugsgröße: "bezüglich Durchschnittswerte", Maximum: 75%, Dauer: 48 Stunden. Für diese Einstellungen werden alle Ereignisse angezeigt, in denen der Anteil an Wind- und PV-Strom am Bedarf über eine Dauer von mindestens 48 Stunden maximal 75% des durchschnittlichen (2015-2020) Anteils an Wind- und PV-Strom am Bedarf betrug. Wenn Sie bezüglich der Durchschnittswerte filtern, können Sie also Ereignisse filtern, in den der Anteil bzw. die Auslastung unterdurchschnittlich war. Diese Bezugsgröße erfordert somit kein Vorwissen über realistische Werte für den Anteil oder die Auslastung. 
      </details>
  </div>
</div>`
)});
  main.variable(observer()).define(["viewof max_percentage_parameter","viewof duration_parameter","rounding","duration_parameter","htl"], function($0,$1,rounding,duration_parameter,htl){return(
htl.html`<div class="row">
    <div class="col-12 col-sm-6">
     ${$0}
      <details class="small">
<summary>Informationen zum Maximum</summary>
Hier geben Sie vor, wie groß der Anteil der gewählten Erneuerbaren am Bedarf beziehungsweise der durchschnittlichen Erzeugung <b>höchstens</b> gewesen sein darf. Je kleiner dieser Wert ist, desto weniger Strom haben die gewählten Erneuerbaren geliefert. Bei dem voreingestellten Wert von 30% sucht das Tool nach Phasen, in denen der Anteil am Bedarf oder der durchschnittlichen Erzeugung zwischen 0 und  30 Prozent gelegen hat. 70% des Strombedarfs mussten dann durch andere Quellen gedeckt werden. Das zeigt Ihnen die Intensität der Dunkelflaute.
</details>
    </div>
    <div class="col-12 col-sm-6">
${$1}
      Die von Ihnen gewählte Dauer in Stunden entspricht ${rounding(duration_parameter/24.0,1).toLocaleString("de")} Tagen.
      <details class="small">
<summary>Informationen zur Dauer</summary>
Hier geben Sie vor, wie lange der oben angewählte Höchstwert für die Erzeugung durch Erneuerbare <b> mindestens</b> gedauert hat. Das Tool sucht dann nach allen Phasen, in denen das gewählte Maximum zu keinem Zeitpunkt überschritten wurde. <br> 
Phasen, in denen die Erzeugung auch nur für kurze Zeit über dem gewählten Erzeugungs-Maximum liegt oder lange Zeiträume, in denen die Erzeugung um das Maximum pendeln, werden <b>nicht</b> angezeigt. Es ist daher sinnvoll, etwas mit den Parametern zu "spielen". Erhöhen Sie  zum Beispiel für eine gewählte Dauer das Erzeugungs-Maximum etwas und beobachten, ob deutlich mehr Ereignisse angezeigt werden. Tritt das auf, ist die höhere Einstellung für die Erzeugung sinnvoll. 
  </div>
</div>`
)});
  main.variable(observer("viewof years_history")).define("viewof years_history", ["Inputs"], function(Inputs){return(
Inputs.checkbox(["2015", "2016", "2017", "2018", "2019", "2020", "2021"], {label: "Betrachtete Jahre", value: ["2015", "2016", "2017", "2018", "2019", "2020", "2021"]})
)});
  main.variable(observer("years_history")).define("years_history", ["Generators", "viewof years_history"], (G, _) => G.input(_));
  main.variable(observer()).define(["html","mutable max_percentage_parameter_function","max_percentage_parameter","mutable duration_parameter_function","duration_parameter","mutable absolute_or_relative_function","absolute_or_relative","mutable filter_criterium_function","filter_criterium","mutable years_history_function","years_history"], function(html,$0,max_percentage_parameter,$1,duration_parameter,$2,absolute_or_relative,$3,filter_criterium,$4,years_history){return(
html`<button id="compute_history" class="btn btn-outline-secondary" onclick=${() => {$0.value = max_percentage_parameter/100.0;
                              $1.value = duration_parameter;
                              $2.value = absolute_or_relative;
                              $3.value = filter_criterium;
                              $4.value = years_history;}}>Dunkelflautensuche starten</button>`
)});
  main.variable(observer()).define(["heat_map_history","text_history","viewof selection_dunkelflauten","htl"], function(heat_map_history,text_history,$0,htl){return(
htl.html`<nav>
  <div class="nav nav-tabs" id="nav-tab" role="tablist">
    <button class="nav-link active" id="nav-vorkommnisse-jahresverlauf-tab" data-bs-toggle="tab" data-bs-target="#nav-vorkommnisse-jahresverlauf" type="button" role="tab" aria-controls="nav-vorkommnisse-jahresverlauf" aria-selected="false">Vorkommnisse im Jahresverlauf</button>
    
    <button class="nav-link" id="nav-informationen-suchergebnis-tab" data-bs-toggle="tab" data-bs-target="#nav-informationen-suchergebnis" type="button" role="tab" aria-controls="nav-informationen-suchergebnis" aria-selected="false">Informationen zum Suchergebnis</button>
    
    <button class="nav-link" id="nav-liste-ereignisse-tab" data-bs-toggle="tab" data-bs-target="#nav-liste-ereignisse" type="button" role="tab" aria-controls="nav-liste-ereignisse" aria-selected="false">Liste aller Ereignisse</button>
  </div>
</nav>
<div class="tab-content" id="nav-tabContent">
  <div class="tab-pane fade show active" id="nav-vorkommnisse-jahresverlauf" role="tabpanel" aria-labelledby="nav-vorkommnisse-jahresverlauf-tab">
      Klicken Sie auf einen Tag um sich den Strombedarf, den Erzeugungsmix und den Anteil von Wind- und PV-Energie an diesem Tag anzeigen zu lassen. 
    ${heat_map_history.rendered}
      <details class="small"><summary>Informationen zur Grafik</summary>
              Die Grafik zeigt alle Zeiträume, in denen die gewählten Parameter auftraten:
              <ul>
                  <li>Auf der y-Achse sind die Jahre angegeben,</li>
                  <li>auf der x-Achse der Beginn im Monat und Tag sowie die Dauer.</li>
                  <li> Die Farbe und der Wert zwischen 1 und 24 zeigen an, an wie viele Stunden der Tag von einem oder mehrern
                      Ereignissen betroffen war.
                      Falls an einem Tag ein Ereignis endete und ein anderes startete, wird die Summe aus allen Stunden
                      angezeigt, die an den Ereignissen beteiligt waren.</li>
                  <li> Sie können die Grafik durch Scrollen vergrößern. </li> <li> Wenn sie auf einen Tag klicken, wird der Zoombereich in
                      der unteren Grafik entsprechend angepasst.</li>
              </ul>
      </details>
    
  
  </div>
  <div class="tab-pane fade" id="nav-informationen-suchergebnis" role="tabpanel" aria-labelledby="nav-informationen-suchergebnis-tab">
    ${text_history}
  </div>
  <div class="tab-pane fade" id="nav-liste-ereignisse" role="tabpanel" aria-labelledby="nav-liste-ereignisse-tab">
      ${$0}
<details class="small"><summary>Informationen zur Tabelle</summary>
              <p>
                  Diese Tabelle listet alle Vorkommnisse, die Ihrer Auswahl entsprechen auf. Sie können der Tabelle das
                  Anfangsdatum und die Dauer des Ereignisses entnehmen, sowie die minimale und durchschnittliche Leistung der PV- und
                  Windkraftanlagen in GW und die maximale Residuallast während des Vorkommnisses.
              </p>
              <p>
                  Durck Anklicken einer Spaltenüberschrift wird die Tabelle nach der gewählen Spalte auf- bzw. absteigend
                  sortiert. Zudem können Sie links neben dem Datum ein bestimmtes Ereignis auswählen. Die folgenden Grafiken
                  werden dann auf den entsprechenden Zeitraum vergrößert.
              </p>
</details>
      </span>
  </div>
</div>`
)});
  main.variable(observer()).define(["titel_history_plot","moment","start_date_history","end_date_history","htl"], function(titel_history_plot,moment,start_date_history,end_date_history,htl){return(
htl.html`<b>${titel_history_plot} und Strommix (${moment.unix(moment(start_date_history).tz('Europe/Berlin').unix()).tz('Europe/Berlin').format("DD.MM.YY HH:mm")} - ${moment.unix(moment(end_date_history).tz('Europe/Berlin').unix()).tz('Europe/Berlin').format("DD.MM.YY HH:mm")}) </b>`
)});
  main.variable(observer("plot_dunkelflauten_all")).define("plot_dunkelflauten_all", ["plot_history_all","data_history","years_history_function","results_analaysis_history","max_percentage_parameter_function","to_plot_history","colors_history"], function(plot_history_all,data_history,years_history_function,results_analaysis_history,max_percentage_parameter_function,to_plot_history,colors_history){return(
plot_history_all(data_history.filter((entry) => years_history_function.includes(entry["Date"].slice(0,4))), results_analaysis_history[1], 0, max_percentage_parameter_function, "Gesamt[MWh]", "Residuallast[MWh]", to_plot_history, colors_history).rendered
)});
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<details class="small"><summary>Informationen zu den Grafiken</summary>
In der oberen Grafik sehen Sie, je nach Filterkreterium und Bezugsgröße, den tastächlichen Anteil am Bearf (bzw. Anteil an installierter Leistung) oder den durchschnittlichen Wert (2015-2020) für jeden Zeitpunkt. In der unteren Grafik sehen Sie aufgeschlüsselt: <ul><li> als Kurven wie hoch die Netzlast sowie die Residuallast lagen <li> als Flächen die erzeugten Energien der beteiligten Kraftwerke. Die Farben werden über der Grafik angezeigt, wenn Sie einen Kreis auswählen, können Sie die angewählte Kurve gezielt aus der Grafik herausnehmen. <li> Falls Sie bereits ein bestimmtes Ereignis ausgewählt haben, zeigt diese Grafik den gewählten Zeitraum.
<li>Die Erzeugungsdaten beziehen sich auf die Erzeugung innerhalb Deutschlands und wurden von der Bundesnetzagentur über ihr Portal <a href="https://www.smard.de/home">SMARD</a> bereitgestellt. Nur der importierte Strom stammt aus eigenen Berechnungen und entspricht der Differenz von Neztlast und Erzeugung. 
</ul> 
Wenn Sie eine Auswahl für einen Zeitraum wie oben beschrieben getroffen haben, wird nur dieser Zeitraum angezeigt. 
</details>`
)});
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<h2 class="hidden">Appenddix</h2>`
)});
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<h2 class="hidden">Style</h2>`
)});
  main.variable(observer()).define(["html","FileAttachment","width"], async function(html,FileAttachment,width){return(
html`<style>

@font-face {
  font-family: "Aller";
  src: local("Aller"), url(${await FileAttachment("Aller_Rg.ttf").url()}) format("truetype");
}

* {
  font-family: "Aller" !important;
}
#body {
  background-image: url(${await FileAttachment("bg.jpg").url()});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
}
.notebook {
  background: #fff;
}
.my-title {
  text-align: center;
  color: #81700f;
  font-size: 46px;
  font-weight: bold;
}



.button {
	cursor: pointer;
	border: 1px solid #8A7705;
  height: 30px;
	background: none;
	box-shadow: none;
	border-radius: 5px; /*angles' curvature*/
	margin: 4px; /*free space around the button*/
  color: #8A7705;
  display: inline-block; /*buttons horizontally aligned*/
  text-align: center;
  padding-left: 5px; /*distance between button border and text*/
  padding-right: 5px;
}

.button:hover {
  background: #f8f3d3;
}

.annotated {
  position: relative;
  display: inline-block;
  background-color: #faf2c5;
  padding-left: 3px;
  padding-right: 3px;
}

.annotated:hover {
  background: #faf2c5;
}

.annotation {
  visibility: hidden;
  background-color: #f8f3d3;
  padding-left: 3px;
  padding-right: 3px;
  position: absolute;
  z-index: 1;
  line-height: 0.1;
  margin-left: 50px;
  min-width: ${width/2.0}px;
  visibility: hidden;
  border: solid 0.5px #666;
  box-shadow: 0 0 5px #ccc;
  padding: 5px;
  position: absolute;
  z-index: 1;
  line-height: 1;
bottom: 60%;
}

.annotated:hover .annotation {
  opacity: 1;
  visibility: visible;
}

/* RANGE BASE STYLE */
input[type=range] {
  -webkit-appearance: none;
  width: 200px;
  height: 3px;
  background: #c6c6c6;
}

input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
}

input[type=range]:focus {
  outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */
}

input[type=range]::-ms-track {
  width: 100%;
  cursor: pointer;

  /* Hides the slider so custom styles can be added */
  background: transparent; 
  border-color: transparent;
  color: transparent;
}

/* RANGE SLIDER THUMB */
input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  //border: 1px solid #000000;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background: #d7c455;
  cursor: pointer;
  /*margin-top: -14px;*/ /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
}

/* All the same stuff for Firefox */
input[type=range]::-moz-range-thumb {
  // border: 1px solid #000000;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background: #d7c455;
  cursor: pointer;
}

/* All the same stuff for IE */
input[type=range]::-ms-thumb {
  //border: 1px solid #000000;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background: #d7c455;
  cursor: pointer;
}

input[type=number], input[type=text] {
  padding: 5px 7px;

  background: #fff;
  border: 1px solid #c6c6c6;
  border-radius: 3px;
} 
input[type=number]:focus-visible, input[type=text]:focus-visible {
  border: 1px solid #d7c455;
  // box-shadow: 0;
  outline: none;
}


/* Style the tab */
.tab {
  overflow: hidden;
  border: 1px solid #ccc;
  background-color: #f1f1f1;
}

/* Style the buttons inside the tab */
.tab button {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
  font-size: 17px;
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: #ddd;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: pink;
}

/* Style the tab content */
.tabcontent {
  display: none;
  padding: 6px 12px;
  border: 1px solid #ccc;
  border-top: none;
}

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  //z-index: auto;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

</style>`
)});
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<h2 class="hidden">Parameter viewof - Initialisierungen</h2>`
)});
  main.variable(observer("viewof filter_criterium")).define("viewof filter_criterium", ["Inputs"], function(Inputs){return(
Inputs.radio(["Anteil Wind und PV an Bedarf", "Anteil alle Erneuerbare am Bedarf", "Anteil an installierter Leistung Wind und PV", "Anteil an installierter Leistung Wind", "Anteil an installierter Leistung PV"], {label: "Filterkriterium", value: "Anteil Wind und PV an Bedarf"})
)});
  main.variable(observer("filter_criterium")).define("filter_criterium", ["Generators", "viewof filter_criterium"], (G, _) => G.input(_));
  main.variable(observer("viewof absolute_or_relative")).define("viewof absolute_or_relative", ["Inputs"], function(Inputs){return(
Inputs.radio(["absolut", "bezüglich Durchschnittswerte"], {label: "Bezugsgröße des Filters", value: "absolut"})
)});
  main.variable(observer("absolute_or_relative")).define("absolute_or_relative", ["Generators", "viewof absolute_or_relative"], (G, _) => G.input(_));
  main.variable(observer("viewof max_percentage_parameter")).define("viewof max_percentage_parameter", ["Inputs"], function(Inputs){return(
Inputs.range([0, 100], {value: 30, step: 1, label: "Maximum in %"})
)});
  main.variable(observer("max_percentage_parameter")).define("max_percentage_parameter", ["Generators", "viewof max_percentage_parameter"], (G, _) => G.input(_));
  main.variable(observer("viewof duration_parameter")).define("viewof duration_parameter", ["Inputs","Event"], function(Inputs,Event){return(
Object.assign(Inputs.range([1, 200], {value: 168, step: 1, label: "Mindestdauer"}), {
  oninput: event => event.isTrusted && event.stopImmediatePropagation(),
  onchange: event => event.currentTarget.dispatchEvent(new Event("input"))})
)});
  main.variable(observer("duration_parameter")).define("duration_parameter", ["Generators", "viewof duration_parameter"], (G, _) => G.input(_));
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<h2 class="hidden">Daten</h2>`
)});
  main.define("initial data_history", ["FileAttachment"], function(FileAttachment){return(
FileAttachment("data_for_history_analysis@1.csv").csv()
)});
  main.variable(observer("mutable data_history")).define("mutable data_history", ["Mutable", "initial data_history"], (M, _) => new M(_));
  main.variable(observer("data_history")).define("data_history", ["mutable data_history"], _ => _.generator);
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<h2 class="hidden">Parameter Szenarien</h2>`
)});
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<h2 class="hidden">Werte, die an Funktionen übergeben werden</h2>`
)});
  main.define("initial max_percentage_parameter_function", function(){return(
0.3
)});
  main.variable(observer("mutable max_percentage_parameter_function")).define("mutable max_percentage_parameter_function", ["Mutable", "initial max_percentage_parameter_function"], (M, _) => new M(_));
  main.variable(observer("max_percentage_parameter_function")).define("max_percentage_parameter_function", ["mutable max_percentage_parameter_function"], _ => _.generator);
  main.define("initial duration_history", function(){return(
168
)});
  main.variable(observer("mutable duration_history")).define("mutable duration_history", ["Mutable", "initial duration_history"], (M, _) => new M(_));
  main.variable(observer("duration_history")).define("duration_history", ["mutable duration_history"], _ => _.generator);
  main.define("initial duration_parameter_function", function(){return(
168
)});
  main.variable(observer("mutable duration_parameter_function")).define("mutable duration_parameter_function", ["Mutable", "initial duration_parameter_function"], (M, _) => new M(_));
  main.variable(observer("duration_parameter_function")).define("duration_parameter_function", ["mutable duration_parameter_function"], _ => _.generator);
  main.define("initial filter_criterium_function", function(){return(
"Anteil Wind und PV an Bedarf"
)});
  main.variable(observer("mutable filter_criterium_function")).define("mutable filter_criterium_function", ["Mutable", "initial filter_criterium_function"], (M, _) => new M(_));
  main.variable(observer("filter_criterium_function")).define("filter_criterium_function", ["mutable filter_criterium_function"], _ => _.generator);
  main.define("initial absolute_or_relative_function", function(){return(
"absolut"
)});
  main.variable(observer("mutable absolute_or_relative_function")).define("mutable absolute_or_relative_function", ["Mutable", "initial absolute_or_relative_function"], (M, _) => new M(_));
  main.variable(observer("absolute_or_relative_function")).define("absolute_or_relative_function", ["mutable absolute_or_relative_function"], _ => _.generator);
  main.define("initial titel_history_plot", function(){return(
"Anteil Strom aus PV- und Windkraftanlagen an Bedarf"
)});
  main.variable(observer("mutable titel_history_plot")).define("mutable titel_history_plot", ["Mutable", "initial titel_history_plot"], (M, _) => new M(_));
  main.variable(observer("titel_history_plot")).define("titel_history_plot", ["mutable titel_history_plot"], _ => _.generator);
  main.define("initial years_history_function", function(){return(
["2015", "2016", "2017", "2018", "2019", "2020", "2021"]
)});
  main.variable(observer("mutable years_history_function")).define("mutable years_history_function", ["Mutable", "initial years_history_function"], (M, _) => new M(_));
  main.variable(observer("years_history_function")).define("years_history_function", ["mutable years_history_function"], _ => _.generator);
  main.define("initial start_date_history", ["set_initial_zoom","results_analaysis_history","years_history_function"], function(set_initial_zoom,results_analaysis_history,years_history_function){return(
set_initial_zoom(results_analaysis_history[2], years_history_function)[0]
)});
  main.variable(observer("mutable start_date_history")).define("mutable start_date_history", ["Mutable", "initial start_date_history"], (M, _) => new M(_));
  main.variable(observer("start_date_history")).define("start_date_history", ["mutable start_date_history"], _ => _.generator);
  main.define("initial end_date_history", ["set_initial_zoom","results_analaysis_history","years_history_function"], function(set_initial_zoom,results_analaysis_history,years_history_function){return(
set_initial_zoom(results_analaysis_history[2], years_history_function)[1]
)});
  main.variable(observer("mutable end_date_history")).define("mutable end_date_history", ["Mutable", "initial end_date_history"], (M, _) => new M(_));
  main.variable(observer("end_date_history")).define("end_date_history", ["mutable end_date_history"], _ => _.generator);
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<h2 class="hidden">Analyseergebnisse</h2>`
)});
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<h3 class="hidden">Historische Auswertung</h3>`
)});
  main.variable(observer("results_analaysis_history")).define("results_analaysis_history", ["generate_analysis_history","data_history","max_percentage_parameter_function","duration_parameter_function","filter_criterium_function","absolute_or_relative_function","years_history_function"], function(generate_analysis_history,data_history,max_percentage_parameter_function,duration_parameter_function,filter_criterium_function,absolute_or_relative_function,years_history_function){return(
generate_analysis_history(data_history, 0, max_percentage_parameter_function, duration_parameter_function,  filter_criterium_function, absolute_or_relative_function, years_history_function)
)});
  main.variable(observer("heat_map_history")).define("heat_map_history", ["plot_heat_map","results_analaysis_history"], function(plot_heat_map,results_analaysis_history){return(
plot_heat_map(results_analaysis_history[1][2])
)});
  main.variable(observer()).define(["selection_dunkelflauten"], function(selection_dunkelflauten){return(
selection_dunkelflauten
)});
  main.variable(observer("text_selector_history")).define("text_selector_history", ["html","moment","rounding"], function(html,moment,rounding){return(
function text_selector_history(results_analaysis_history) {
  try {
    var text = html`Die eingestellten Filter führten nun zu folgendem Ergebnis: <ul> 
<li> Im gewählten Zeitraum traten <b>${results_analaysis_history[0]["anzahl_dunkelflauten"]}</b> Perioden auf, die der gewählten Definition entsprechen. 
  
<li> Das längste Vorkomnis hatte eine Dauer von <b>${results_analaysis_history[0]["laengste_dunkelflaute"][1]} Stunden </b>. Es begann am <b>${ moment.unix(results_analaysis_history[0]["laengste_dunkelflaute"][0]).tz('Europe/Berlin').format("DD.MM.YYYY")}</b> um <b>${moment.unix(results_analaysis_history[0]["laengste_dunkelflaute"][0]).tz('Europe/Berlin').format("HH:mm") }</b> Uhr.
  
<li> Die maximale Residuallast im gesamten Zeitraum betrug  <b>${rounding(results_analaysis_history[0]["maximale_residuallast"]/1000,2).toLocaleString("de")} GW</b> (${rounding(100*results_analaysis_history[0]["verhaeltnis_max_residuallast_netzlast"],2).toLocaleString("de")} % des Bedarfs)  und trat am <b>${ moment.unix(results_analaysis_history[0]["maximale_residuallast_datum"]).tz('Europe/Berlin').format("DD.MM.YYYY")}</b> um <b>${moment.unix(results_analaysis_history[0]["maximale_residuallast_datum"]).tz('Europe/Berlin').format("HH:mm") }</b> Uhr auf. 
  
<li> Insgesamt dauerten alle Ereignisse, die den Suchkriterien entsprachen <b> ${results_analaysis_history[0]["gesamtstunden_dunkelflaute"].toLocaleString("de")} Stunden</b>. Das entspricht einem Anteil von  <b>${rounding(results_analaysis_history[0]["anteil_dunkelflauten"]*100,2).toLocaleString("de")} % </b> am Gesamtzeitraum.  
  
  </ul>`
  } catch (TypeError) {
    text = html`Die eingestellten Filter führte nun zu folgendem Ergebnis: <ul> 
<li> Im gewählten Zeitraum traten <b>0</b> Perioden auf, die der gewählten Definition entsprechen. 
  
<li> Die maximale Residuallast im gesamten Zeitraum betrug   <b>${rounding(results_analaysis_history[0]["maximale_residuallast"]/1000,2).toLocaleString("de")} GW</b> (${rounding(100*results_analaysis_history[0]["verhaeltnis_max_residuallast_netzlast"],2).toLocaleString("de")} % des Bedarfs) und trat am <b>${ moment.unix(results_analaysis_history[0]["maximale_residuallast_datum"]).tz('Europe/Berlin').format("DD.MM.YYYY")}</b> um <b>${moment.unix(results_analaysis_history[0]["maximale_residuallast_datum"]).tz('Europe/Berlin').format("HH:mm") }</b> Uhr auf. 
  
  </ul>`
  }
  return text
}
)});
  main.variable(observer("text_history")).define("text_history", ["text_selector_history","results_analaysis_history"], function(text_selector_history,results_analaysis_history){return(
text_selector_history(results_analaysis_history)
)});
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<p class="hidden"> viewof_selection_dunkelflauten</p>`
)});
  main.variable(observer("viewof selection_dunkelflauten")).define("viewof selection_dunkelflauten", ["Inputs","results_analaysis_history"], function(Inputs,results_analaysis_history){return(
Inputs.table(results_analaysis_history[2], {required: false, multiple:false, sort: "Datum", 
  format: {
     "Wind und PV Mimimum (GW)": x => x.toLocaleString("de"),
    "Wind und PV Durchschnitt (GW)": x => x.toLocaleString("de"),
      "Maximale Residuallast (GW)": x => x.toLocaleString("de")
  },
align: {
     "Wind und PV Mimimum (GW)": "right",
    "Wind und PV Durchschnitt (GW)": "right",
      "Maximale Residuallast (GW)": "right"
  }})
)});
  main.variable(observer("selection_dunkelflauten")).define("selection_dunkelflauten", ["Generators", "viewof selection_dunkelflauten"], (G, _) => G.input(_));
  main.variable(observer()).define(["set_zoom_history","selection_dunkelflauten"], function(set_zoom_history,selection_dunkelflauten){return(
set_zoom_history(selection_dunkelflauten)
)});
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<h2 class="hidden">Variablen für Auswertungstexte</h2>`
)});
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<h2 class="hidden">Konstanten</h2>`
)});
  main.variable(observer("dates_of_a_year_365")).define("dates_of_a_year_365", ["getDates"], function(getDates){return(
getDates("2015-01-01", "2015-12-31", "DD.MM")
)});
  main.variable(observer("dates_of_a_year_366")).define("dates_of_a_year_366", ["getDates"], function(getDates){return(
getDates("2016-01-01", "2016-12-31", "DD.MM")
)});
  main.variable(observer("dates_2015")).define("dates_2015", ["getDates"], function(getDates){return(
getDates("2015-01-01", "2015-12-31", "YYYY/MM/DD")
)});
  main.variable(observer("dates_2016")).define("dates_2016", ["getDates"], function(getDates){return(
getDates("2016-01-01", "2016-12-31", "YYYY/MM/DD")
)});
  main.variable(observer("dates_2017")).define("dates_2017", ["getDates"], function(getDates){return(
getDates("2017-01-01", "2017-12-31", "YYYY/MM/DD")
)});
  main.variable(observer("dates_2018")).define("dates_2018", ["getDates"], function(getDates){return(
getDates("2018-01-01", "2018-12-31", "YYYY/MM/DD")
)});
  main.variable(observer("dates_2019")).define("dates_2019", ["getDates"], function(getDates){return(
getDates("2019-01-01", "2019-12-31", "YYYY/MM/DD")
)});
  main.variable(observer("dates_2020")).define("dates_2020", ["getDates"], function(getDates){return(
getDates("2020-01-01", "2020-12-31", "YYYY/MM/DD")
)});
  main.variable(observer("dates_2021")).define("dates_2021", ["getDates"], function(getDates){return(
getDates("2021-01-01", "2021-12-31", "YYYY/MM/DD")
)});
  main.variable(observer("to_plot_history")).define("to_plot_history", function(){return(
["Wasserkraft[MWh]", "Biomasse[MWh]", "Kernenergie[MWh]", "Braunkohle[MWh]", "Steinkohle[MWh]","Erdgas[MWh]", "Sonstige Konventionelle[MWh]", "Sonstige Erneuerbare[MWh]","Pumpspeicher[MWh]", "Import[MWh]", "Wind Offshore[MWh]","Wind Onshore[MWh]","Photovoltaik[MWh]"]
)});
  main.variable(observer("colors_history")).define("colors_history", function(){return(
["#000000", "#2403fc", "#a5fc03", "#fc0303", "#956415", "#000000", "#9922aa", "#cc0000", "#9fc5e8", "#2986cc",  "#fcad03", "#b6d7a8", "#38761d", "#ffdd77", "#000000","#000000"]
)});
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<h1 class="hidden">Funktionen</h1>`
)});
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<h3 class="hidden">Anwendungsbezogene Funktionen</h3>`
)});
  main.variable(observer("data_filter")).define("data_filter", function(){return(
function data_filter(data, threshold_min, threshold_max, column) {
  /**
  Return data where the values of the specified column are between the given minimal and maximal threshold 
  */
  return data.filter((entry) => threshold_min <= Number(entry[column])   &&  entry[column] <= Number(threshold_max));
}
)});
  main.variable(observer("compute_dunkelflauten")).define("compute_dunkelflauten", ["_","moment","substract","rounding","get_year_index"], function(_,moment,substract,rounding,get_year_index){return(
function(data, duration, extraction_mode, compute_heat_map_data) {
 /**
 Compute batches of consecutive time stamps
 */
  var dunkelflaute_start = [];
  var dunkelflaute_duration = [];
  var dunkelflaute_heat_map_data = [];
  var considered_days= [];
  var dunkelflaute_table_information = [];

  var current_batch_number = 0;
  var batch_correspondence = [];
  var current_batch_length = 1;
  var batch_length = [];
  var all_dates = _.pluck(data, "Date").map(String);
  if (all_dates.length == 0){
      return [dunkelflaute_start, dunkelflaute_duration,dunkelflaute_heat_map_data, dunkelflaute_table_information];
  }
  var all_dates_unix = _.pluck(data, "Unix Time Stamp").map(Number);
  var first_unix_timestamp = all_dates_unix[0];
  var distance_time = 0;
  for (var i = 0; i < all_dates.length - 1; i++) {
      distance_time = all_dates_unix[i+1] - all_dates_unix[i];
      if (distance_time > 3600) {
          batch_length.push(current_batch_length);
          batch_correspondence.push(current_batch_number);
          current_batch_length = 1;
          current_batch_number += 1; 
      }
      else {
          batch_correspondence.push(current_batch_number);
          current_batch_length += 1; 
      }  
  }
  batch_length.push(current_batch_length);
  batch_correspondence.push(current_batch_number)
  /**
  Filters all batches of length at least "duration"
  */
  var start_date_index = 0;
  var dunkelflaute_start_unix;

  var dunkelflaute_of_maximum_duration;
  var maximum_duration = 0;
  
  batch_length.forEach(function(element) { 
    var rest_of_day;
    var number_of_full_days;
    var rest_of_dunkelflaute; 
    var heat_map_start_day;
    var heat_map_start_day_duration;
    var heat_map_start_day_rest_of_day;
    var day_year;
    var day_year_data;
    var time_stamp;

    
    if (element >= duration) {
      // add length and start data of dunkelflaute to arrays
      dunkelflaute_duration.push(element);
      dunkelflaute_start_unix = all_dates_unix[start_date_index];
      dunkelflaute_start.push(moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').format("YYYY/MM/DD HH:mm"))
      
      // compute all relevant information of the dunkelflaute 
      if (extraction_mode == "history") {
        //var data_during_dunkelflaute = data.filter((entry) => dunkelflaute_start_unix <= entry["Unix Time Stamp"]   &&  
        //                                        entry["Unix Time Stamp"] <= dunkelflaute_start_unix + 3600*element);
        var data_during_dunkelflaute = data.slice(start_date_index,start_date_index+element);
        var percentage_wind_pv = _.pluck(data_during_dunkelflaute, "Anteil an Verbrauch Wind PV").map(Number);
        var demand_data = _.pluck(data_during_dunkelflaute, "Gesamt[MWh]").map(Number)
        var demand = demand_data.reduce((pv, cv) => pv + cv, 0)/1000.0;
        var residual_data = _.pluck(data_during_dunkelflaute, "Residual PV Wind").map(Number);
        //var residual = residual_data.reduce((pv, cv) => pv + cv, 0);
        var solar_wind = substract(demand_data, residual_data)
        var residual_renewable = _.pluck(data_during_dunkelflaute, "Residual EEG").map(Number).reduce((pv, cv) => pv + cv, 0);
        dunkelflaute_table_information.push({
          "Datum": all_dates[start_date_index],
          "Dauer in Stunden": element,
          //"Minimaler Anteil Wind und PV" : Math.min(...percentage_wind_pv),
         //"Maximaler Anteil Wind und PV" : Math.max(...percentage_wind_pv), 
          "Wind und PV Mimimum (GW)": rounding(Math.min(...solar_wind)/1000,2), 
          "Wind und PV Durchschnitt (GW)": rounding(solar_wind.reduce((pv, cv) => pv + cv, 0)/1000/element,2),
          //"Anteil an installierter Leistung": rounding(_.pluck(data_during_dunkelflaute, "Leistung pro installierte Einheit Wind PV").map(Number).reduce((pv, cv) => pv + cv, 0)/element,2),
          "Maximale Residuallast (GW)": rounding(Math.max(...residual_data)/1000,2).toLocaleString('de') ,
          //"Sonstige EE (GW)": rounding((residual-residual_renewable)/element/1000,2).toLocaleString('de') ,
          //"Braunkohle (GW)": rounding(_.pluck(data_during_dunkelflaute, "Braunkohle[MWh]").map(Number).reduce((pv, cv) => pv + cv, 0)/element/1000,2).toLocaleString('de') ,
          //"Steinkohle (GW)": rounding(_.pluck(data_during_dunkelflaute, "Steinkohle[MWh]").map(Number).reduce((pv, cv) => pv + cv, 0)/element/1000,2).toLocaleString('de'), 
           //"Erdgas (GW)": rounding(_.pluck(data_during_dunkelflaute, "Erdgas[MWh]").map(Number).reduce((pv, cv) => pv + cv, 0)/element/1000,2).toLocaleString('de') 
       });
      }
      else if (extraction_mode == "scenario") {
        var data_during_dunkelflaute = data.slice(start_date_index,start_date_index+element);
        var percentage_wind_pv = _.pluck(data_during_dunkelflaute, "Anteil PV und Wind").map(Number);     
        var wind_pv = _.pluck(data_during_dunkelflaute, "PV und Wind").map(Number);     
        var residual_data = _.pluck(data_during_dunkelflaute, "Residual Wind PV Szenario").map(Number);
        var residual = residual_data.reduce((pv, cv) => pv + cv, 0);
        var residual_renewable = _.pluck(data_during_dunkelflaute, "Residual EEG Szenario").map(Number).reduce((pv, cv) => pv + cv, 0);
        var total = _.pluck(data_during_dunkelflaute, "Bedarf und Laden").map(Number).reduce((pv, cv) => pv + cv, 0);
        dunkelflaute_table_information.push({
          "Datum": all_dates[start_date_index],
          "Dauer in Stunden": element,   
          "Minimum Wind und PV (GW)": rounding(Math.min(...wind_pv)/1000,2),
          "Durchschnitt Wind und PV (GW)": rounding(wind_pv.reduce((pv, cv) => pv + cv, 0)/1000/element,2),
          "Maximale Residuallast (GW)": rounding(Math.max(...residual_data)/1000,2),
          //"EE + Grundlast":  rounding((residual-residual_renewable)/element/1000,2).toLocaleString('de') ,
          //"Braunkohle (flexibel)": rounding(_.pluck(data_during_dunkelflaute, "Braunkohle Szenario flexibel").map(Number).reduce((pv, cv) => pv + cv,0)/element/1000,2),
          //"Steinkohle": rounding(_.pluck(data_during_dunkelflaute, "Steinkohle Szenario").map(Number).reduce((pv, cv) => pv + cv, 0)/element/1000,2),
          //"Gas": rounding(_.pluck(data_during_dunkelflaute, "Gasturbinen").map(Number).reduce((pv, cv) => pv + cv, 0)/element/1000,2).toLocaleString('de') , 
          //"Lücke": Math.abs(rounding(_.pluck(data_during_dunkelflaute, "Residual Mix").map(Number).reduce((pv, cv) => pv + cv, 0)/1000,2)).toLocaleString('de') ,
          //"Lücke %": Math.abs(rounding(100*(_.pluck(data_during_dunkelflaute, "Residual Mix").map(Number).reduce((pv, cv) => pv + cv, 0))/total,2)).toLocaleString('de') ,
          "Maximale Versorgungslücke (GW)": Math.abs(rounding(Math.max(...(_.pluck(data_during_dunkelflaute, "Residual Mix").map(Number)))/1000,2))
       });
          
      } 
      else {
      }
    
      if (compute_heat_map_data) {
        // compute heat map value for all days a dunkelflaute consists of 
        rest_of_day = 24 - moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').hour();
        // handle dunkelflaute if duration is at most rest of day
        heat_map_start_day = String(moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').dayOfYear()-1) + "-" + 
          String(moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').year());
        heat_map_start_day_duration = [moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').dayOfYear()-1, 
                                       get_year_index(moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').year()), element];
        heat_map_start_day_rest_of_day = [moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').dayOfYear()-1, 
                                          get_year_index(moment.unix(dunkelflaute_start_unix).tz('Europe/Berlin').year()), rest_of_day];
        if (rest_of_day >= element) {
          if (considered_days.includes(heat_map_start_day)) {
            dunkelflaute_heat_map_data[considered_days.indexOf(heat_map_start_day)][2] += element;
          }
          else {
            dunkelflaute_heat_map_data.push(heat_map_start_day_duration);
            considered_days.push(heat_map_start_day);
          }
        }
        else {
          number_of_full_days = Math.floor(1.0*(element - rest_of_day)/24); 
          rest_of_dunkelflaute  = (element - rest_of_day) % 24;
          if (considered_days.includes(heat_map_start_day)) {
            dunkelflaute_heat_map_data[considered_days.indexOf(heat_map_start_day)][2] += rest_of_day;

          }
          else {
            dunkelflaute_heat_map_data.push(heat_map_start_day_rest_of_day);
            considered_days.push(heat_map_start_day);
          }
          for (i = 1; i <= number_of_full_days; i++) {
            time_stamp = dunkelflaute_start_unix + 24*i*3600;
            day_year = String(moment.unix(time_stamp).tz('Europe/Berlin').dayOfYear()-1) + "-" + 
              String(moment.unix(time_stamp).tz('Europe/Berlin').year());
            day_year_data = [moment.unix(time_stamp).tz('Europe/Berlin').dayOfYear()-1, 
                             get_year_index(moment.unix(time_stamp).tz('Europe/Berlin').year()), 24];
            dunkelflaute_heat_map_data.push(day_year_data);
            considered_days.push(day_year);
          }
          if (rest_of_dunkelflaute > 0) {
            time_stamp = dunkelflaute_start_unix + 24*(number_of_full_days+1)*3600;
            day_year = String(moment.unix(time_stamp).tz('Europe/Berlin').dayOfYear()-1) + "-" + 
              String(moment.unix(time_stamp).tz('Europe/Berlin').year());
            day_year_data = [moment.unix(time_stamp).tz('Europe/Berlin').dayOfYear()-1, 
                             get_year_index(moment.unix(time_stamp).tz('Europe/Berlin').year()), rest_of_dunkelflaute]
            dunkelflaute_heat_map_data.push(day_year_data);
            considered_days.push(day_year);   
          }  
        }
    }
      if (element > maximum_duration) {
        maximum_duration = element; 
        dunkelflaute_of_maximum_duration = [dunkelflaute_start_unix, element];

      }
    }
    start_date_index += element;
  });
  return [dunkelflaute_start, dunkelflaute_duration, dunkelflaute_heat_map_data, dunkelflaute_table_information, dunkelflaute_of_maximum_duration];
  }
)});
  main.variable(observer("generate_analysis_history")).define("generate_analysis_history", ["mutable titel_history_plot","_","compute_dunkelflauten","moment"], function($0,_,compute_dunkelflauten,moment){return(
function generate_analysis_history(data, threshold_min, threshold_max, duration, filter_criterium, absolute_or_relative_function, years_history) {
    /**
   Generate analyis, both values to be displayed and data to be plotted
    Args:
         data (Array[Dict]): Data of the demand and the power generation. Each entry of the array contains data of one specific hour
         threshold_min (Number): lower bound of filter
         threshold_max (Number): upper bound of filter
         duration (Number): Mimimum Duration of an event
         filter_criterium (String): Specifies the filter criterium 
         absolute_or_relative_function (String): Specifies weather to filter w.r.t. to average value or w.r.t. actual value of each hour 
      Returns:
        data_to_be_displayed (JSON): Variables that are shown in the dynamic text fields
        data_to_be_plotted (Array[Array]): dates, values (depending on filter criterium), data for the heat map
        table_data (Array[JSON]): Information of the events such as minimal power supply from wind and pv plants
    */
    // Consider selected years only
  console.log("Params for analysis:", data, threshold_min, threshold_max, duration, filter_criterium, absolute_or_relative_function, years_history)
    data = data.filter((entry) => years_history.includes(entry["Date"].slice(0,4)))
    // Filter data for given filter criterium
    if (absolute_or_relative_function == "absolut") {
    if (filter_criterium == "Anteil Wind und PV an Bedarf") {
        var column = "Anteil an Verbrauch Wind PV";
        $0.value = "Anteil Strom aus PV- und Windkraftanlagen an Bedarf"
        var data_filtered = data.filter((entry) => threshold_min <= entry[column]   &&  entry[column] <= threshold_max);
    }
    else if (filter_criterium == "Anteil alle Erneuerbare am Bedarf") {
        var column = "Anteil an Verbrauch";
        $0.value = "Anteil Strom aus EE-Anlagen an Bedarf"
        var data_filtered = data.filter((entry) => threshold_min <= entry[column]   &&  entry[column] <= threshold_max);
    }
    else if (filter_criterium == "Anteil an installierter Leistung Wind und PV") {
        var column = "Leistung pro installierte Einheit Wind PV";
        $0.value = "Leistung von Windkraft und PV-Anlagen pro installierter Einheit"
        var data_filtered = data.filter((entry) => threshold_min <= entry[column]   &&  entry[column] <= threshold_max);
    }
    else if (filter_criterium == "Anteil an installierter Leistung Wind") {
        var column = "Leistung pro installierte Einheit Wind";
        $0.value = "Leistung von Windkraftanlagen pro installierter Einheit"
        var data_filtered = data.filter((entry) => threshold_min <= entry[column]   &&  entry[column] <= threshold_max);
    }
    else if (filter_criterium == "Anteil an installierter Leistung PV") {
        var column = "Leistung pro installierte Einheit PV";
        $0.value = "Leistung von PV-Anlagen pro installierter Einheit"
        var data_filtered = data.filter((entry) => threshold_min <= entry[column]   &&  entry[column] <= threshold_max);
    }
    }
    else {
    if (filter_criterium == "Anteil Wind und PV an Bedarf") {
        $0.value = "Durchschnittlicher Anteil Strom aus PV- und Windkraftanlagen an Bedarf"
        var column = "Anteil an Verbrauch Wind PV Durchschnitt";
        var data_filtered = data.filter((entry) => entry["Anteil an Verbrauch Wind PV"] >= threshold_min*entry[column]   &&  entry["Anteil an Verbrauch Wind PV"] <= threshold_max*entry[column]);
    }
    else if (filter_criterium == "Anteil alle Erneuerbare am Bedarf") {
        var column = "Anteil an Verbrauch Durchschnitt";
        $0.value = "Durchschnittlicher Anteil Strom aus EE-Anlagen an Bedarf"
        var data_filtered = data.filter((entry) => entry["Anteil an Verbrauch Wind PV"] >= threshold_min*entry[column]   &&  entry["Anteil an Verbrauch Wind PV"] <= threshold_max*entry[column]);
    }
    else if (filter_criterium == "Anteil an installierter Leistung Wind und PV") {
        var column = "Leistung pro installierte Einheit Wind PV Durchschnitt";
        $0.value = "Durchschnittliche Leistung von Windkraft und PV-Anlagen pro installierter Einheit"
        var data_filtered = data.filter((entry) => entry["Leistung pro installierte Einheit Wind PV"] >= threshold_min*entry[column]   &&  entry["Leistung pro installierte Einheit Wind PV"] <= threshold_max*entry[column]);
    }
    else if (filter_criterium == "Anteil an installierter Leistung Wind") {
        var column = "Leistung pro installierte Einheit Wind Durchschnitt";
        $0.value = "Durchschnittliche Leistung von Windkraftanlagen pro installierter Einheit"
        var data_filtered = data.filter((entry) => entry["Leistung pro installierte Einheit Wind"] >= threshold_min*entry[column]   &&  entry["Leistung pro installierte Einheit Wind"] <= threshold_max*entry[column]);
    }
    else if (filter_criterium == "Anteil an installierter Leistung PV") {
        var column = "Leistung pro installierte Einheit PV Durchschnitt";
        $0.value = "Durchschnittliche Leistung von PV-Anlagen pro installierter Einheit"
        var data_filtered = data.filter((entry) => entry["Leistung pro installierte Einheit PV"] >= threshold_min*entry[column]   &&  entry["Leistung pro installierte Einheit PV"] <= threshold_max*entry[column]);
    }
    
    }
    // Analysis
    var length_of_history_data = data.length;
    var residuals = _.pluck(data, "Residual PV Wind").map(Number);
    var max_residual = Math.max(...residuals);
    var max_residual_realized = _.pluck(data, "Unix Time Stamp")[residuals.indexOf(max_residual)];
    var demand_at_max_residual_realized = Number(_.pluck(data, "Gesamt[MWh]")[residuals.indexOf(max_residual)]);
    var demand_residual_ratio = 1.0*max_residual/demand_at_max_residual_realized;  

    
    var dunkelflauten = compute_dunkelflauten(data_filtered, duration, "history", true)
    var heat_map_data = dunkelflauten[2];
    var table_data = dunkelflauten[3];
    var dunkelflaute_of_maximum_duration = dunkelflauten[4];

    // Data to be plotted
    var all_dates_unix = _.pluck(data, "Unix Time Stamp").map(Number);   
    var time_data = all_dates_unix.map(timestamp => {return moment.unix(timestamp).tz('Europe/Berlin').format("YYYY/MM/DD HH:mm");})
    var value_data = _.pluck(data, column); //"Anteil an Verbrauch Wind PV"
    var data_to_be_plotted = [time_data, value_data, heat_map_data];
    
    // Variables to be displayed in Textcells
    var total_time_within_threshold = data_filtered.length;
    var ratio_hours_dunkelflauten = 1.0*dunkelflauten[1].reduce((pv, cv) => pv + cv, 0)/length_of_history_data;
    var number_of_dunkelflauten = dunkelflauten[0].length;
    var ratio_hours_within_threshold = 1.0*total_time_within_threshold/length_of_history_data;
    var data_to_be_displayed = {
        "anzahl_dunkelflauten": number_of_dunkelflauten, 
        "anteil_dunkelflauten": ratio_hours_dunkelflauten, 
        "anteil_stunden_innerhalb_min_max": ratio_hours_within_threshold, 
        "maximale_residuallast": max_residual, 
        "maximale_residuallast_datum": max_residual_realized, 
        "laengste_dunkelflaute": dunkelflaute_of_maximum_duration, 
        "gesamtstunden_dunkelflaute": 1.0*dunkelflauten[1].reduce((pv, cv) => pv + cv, 0), 
        "verhaeltnis_max_residuallast_netzlast": demand_residual_ratio};
    console.log("Computed History Analysis");
    // If there is no event return "empty" table
    if (heat_map_data.length == 0) {
    table_data.push({
            "Datum": "-",
            "Dauer": "-",
            "Anteil Wind und PV": "-",
            "Max. Residuallast GW": "-",
            "EE": "-",
            "Braunkohle": "-",
            "Steinkohle": "-",
            "Erdgas": "-",
        });
    }
    return [data_to_be_displayed, data_to_be_plotted, table_data];
}
)});
  main.variable(observer("plot_history_all")).define("plot_history_all", ["_","start_date_history","end_date_history","draw_echart"], function(_,start_date_history,end_date_history,draw_echart){return(
function plot_history_all(data, data_to_be_plotted, threshold_min, threshold_max, demand, residual, to_plot, colors) {
  var series=
        [{
            name: 'Anteil' ,
            type: 'line',
          symbolSize:1,
            data: data_to_be_plotted[1].map(element => (element*100).toFixed(2)),
            markLine: {
                silent: true,
                lineStyle: {
                    color: '#333'
                },
                data: [{
                    yAxis: threshold_min*100
                }, {
                    yAxis: threshold_max*100
                }]
            }
            
        }];
  

to_plot.forEach((element, index) => { 
      series.push({
      sampling: 'average',
      large: true,
      showSymbol: false,
       xAxisIndex: 1,
       yAxisIndex: 1,
        name: element.substring(0, element.length - 5), 
        type: 'line',
          symbolSize:1,
        stack: 'stack',
        areaStyle: {color: colors[index+1]},
        lineStyle: {
         width: 0.1,
          color: colors[index+1]
       },
        emphasis: {
        focus: 'series'
      },
        data: _.pluck(data, element).map(item => (parseFloat(item)/1000).toFixed(2))
      });
    })
    
  series.push({
      sampling: 'average',
      large: true,
       xAxisIndex: 1,
       yAxisIndex: 1,
       name: "Bedarf (Netzlast)",
       type: 'line', 
      symbolSize:1,
       lineStyle: {
         width: 1,
         color: "#000"
       
       },
       data: _.pluck(data, demand).map(item => (parseFloat(item)/1000).toFixed(2)) 
     });

  
     series.push({
      sampling: 'average',
      large: true,
      sampling: 'average',
      large: true,
       xAxisIndex: 1,
       yAxisIndex: 1,
       name: "Residuallast",
       type: 'line', 
         symbolSize:1,
       lineStyle: {
         width: 1,
         color: "#000", 
         type: "dashed"
       
       },
       data: _.pluck(data, residual).map(item => (parseFloat(item)/1000).toFixed(2)) 
     });

  
  var echartOptions= ({
    color: colors,
    tooltip: {
        trigger: 'axis',
        order : 'seriesDesc'
    },
    legend: {
        data: ['Dauer der Dunkelflaute', 'Anteil PV und Wind an Gesamtbedarf'],
        left: 10
    },
    toolbox: {
        feature: {
            restore: {},
            saveAsImage: {
              name: "Bedarf_und_Erzeugung"
            }
        }
    },
   
    dataZoom: [
        {
          startValue: start_date_history,
          endValue: end_date_history,
          xAxisIndex: [0, 1]
          
          
        },
        {
            type: 'inside',
          xAxisIndex: [0, 1]
        }
    ],
   legend: [{
      data: to_plot.map(name => name.substring(0, name.length - 5)),
      top: '30%', 
     icon: 'rect'
      }, 
      {
      data: ["Bedarf (Netzlast)", "Residuallast"],
      top: '37%'
     },
     ],

    visualMap: {
      seriesIndex:0,
            show: false,
            top: 50,
            right: 10,
            pieces: [{
                gt: 0,
                lte: threshold_min*100,
                color: '#D3D3D3'
            }, {
                gt: threshold_min*100,
                lte: threshold_max*100,
                color: '#FC7D02'
            }, {
                gt: threshold_max*100,
                color: '#D3D3D3'
            }
            ]
        },
     grid: [
    {
      left: 60,
      right: 50,
      height: '15%'
    },
    {
      left: 60,
      right: 50,
      top: '45%',
      height: '40%'
    }
  ],
    xAxis:
        [{
            data: data_to_be_plotted[0]
        }, 
         {
           gridIndex: 1,
           data: data_to_be_plotted[0],
         }
        ],

    yAxis: [{
      name: "Anteil in %"
    },
    {
      name: "Leistung in GW",
      gridIndex:1
    }
    ],
    series
    });
    return draw_echart(echartOptions, "bar", document.getElementsByClassName("observablehq")[0].parentElement.offsetWidth, 700)
}
)});
  main.variable(observer("plot_heat_map")).define("plot_heat_map", ["dates_of_a_year_366","get_date_by_year_dayOfYear","draw_echart"], function(dates_of_a_year_366,get_date_by_year_dayOfYear,draw_echart){return(
function plot_heat_map(data_to_be_plotted) {
 var days = dates_of_a_year_366;// Array.from(Array(367).keys()).map(String).slice(1,367);
 var years = ['2015', '2016', '2017',
        '2018', '2019', '2020', '2021'];

 var echartOptions = {

   toolbox: {
        feature: {
            restore: {},
            saveAsImage: {
              name: "dunkelflauten"
            }
        }
    },
   
    tooltip: {
        position: 'top',
        formatter: function (params) {
        
        return "Datum: " + get_date_by_year_dayOfYear(params.value[1], params.value[0])+ "  Dunkelflautenstunden: " + String(params.value[2]);
      }
        
        
    },
  
    xAxis: {
        type: 'category',
        data: days,
        splitArea: {
            show: true
        }
    },
    yAxis: {
        type: 'category',
        data: years,
        splitArea: {
            show: true
        }
    },
    visualMap: {
        min: 0,
        max: 24,
        calculable: true,
        orient: 'vertical',
        left: 'center',
        bottom: '25%', 
        align: 'right', 
        left: '92%'
    },
   dataZoom: {
            type: 'inside',
            realtime: true,
            xAxisIndex: [0, 1]
   },
    series: [{
        name: 'Dunkelflauten',
        type: 'heatmap',
        data: data_to_be_plotted,
        label: {
            show: false
        },
        emphasis: {
            itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
        }
    }]
};
 return draw_echart(echartOptions, "heat_map", document.getElementsByClassName("observablehq")[0].parentElement.offsetWidth, 330)
}
)});
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<h3 class="hidden">Hilfsfunktionen</h3>`
)});
  main.variable(observer("substract")).define("substract", function(){return(
function substract(arr1, arr2) {
  let x = [];
  for(let i = 0;i<=arr2.length-1;i++)
  x.push(arr1[i] - arr2[i]);
  return(x)
}
)});
  main.variable(observer("addition")).define("addition", function(){return(
function addition(arr1, arr2) {
  let x = [];
  for(let i = 0;i<=arr2.length-1;i++)
  x.push(arr1[i] + arr2[i]);
  return(x)
}
)});
  main.variable(observer("second_max")).define("second_max", function(){return(
function (arr){ 
    var max = Math.max.apply(null, arr), // get the max of the array
        maxi = arr.indexOf(max);
    arr[maxi] = -Infinity; // replace max in the array with -infinity
    var secondMax = Math.max.apply(null, arr); // get the new max 
    arr[maxi] = max;
    return secondMax;
}
)});
  main.variable(observer("rounding")).define("rounding", function(){return(
function rounding(number, precission) {
  var roundedString = parseFloat(number.toFixed(precission));
  return Number(roundedString);
}
)});
  main.variable(observer("draw_echart")).define("draw_echart", ["html","echarts"], function(html,echarts){return(
function draw_echart(option, div_name, w, h) {
  var div = html`<div id=${div_name} style="width:${w}px;height:${h}px;" ></div>`;
  var chart = echarts.init(div, null, {renderer: 'svg'});
  option && chart.setOption(option);
  
  return {
    rendered: div,
    chart_backend : chart,
    data: option
  }
}
)});
  main.variable(observer("set")).define("set", ["Event"], function(Event){return(
function set(input, value) {
  input.value = value;
  input.dispatchEvent(new Event("input"));
}
)});
  main.variable(observer("get_year_index")).define("get_year_index", function(){return(
function get_year_index(year) {
  switch (year) {
    case 2015: return 0;
    case 2016: return 1;
    case 2017: return 2;
    case 2018: return 3;
    case 2019: return 4; 
    case 2020: return 5;
    case 2021: return 6;
    default: console.log("Invalid year");
  }
}
)});
  main.variable(observer("getDates")).define("getDates", ["moment"], function(moment){return(
function getDates(startDate, stopDate, format) {
    var dateArray = [];
    var currentDate = moment(startDate);
    var stopDate = moment(stopDate);
    while (currentDate <= stopDate) {
        dateArray.push( moment(currentDate).format(format) )
        currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
}
)});
  main.variable(observer("get_date_by_year_dayOfYear")).define("get_date_by_year_dayOfYear", ["dates_of_a_year_366","dates_of_a_year_365"], function(dates_of_a_year_366,dates_of_a_year_365){return(
function get_date_by_year_dayOfYear(year, day) {
  if ([1,5].includes(year)){
    return dates_of_a_year_366[day];
  }
  else {
    return dates_of_a_year_365[day];
  }
  
}
)});
  main.variable(observer("get_date_by_year_day_full_date")).define("get_date_by_year_day_full_date", ["dates_2015","dates_2016","dates_2017","dates_2018","dates_2019","dates_2020","dates_2021"], function(dates_2015,dates_2016,dates_2017,dates_2018,dates_2019,dates_2020,dates_2021){return(
function get_date_by_year_day_full_date(year, day) {
  console.log("Year, DAY", year, day);
  switch (year) {
    case 0: return dates_2015[day];
    case 1: return dates_2016[day];
    case 2: return dates_2017[day];
    case 3: return dates_2018[day];
    case 4: return dates_2019[day]; 
    case 5: return dates_2020[day];
    case 6: return dates_2021[day];
    default: console.log("Invalid year");
  }
}
)});
  main.variable(observer("set_initial_zoom")).define("set_initial_zoom", ["moment"], function(moment){return(
function set_initial_zoom(analysis_result, selected_years) {
  if (analysis_result[0]["Datum"] == "-") {
    return [selected_years[0]+"/01/01 00:00", selected_years[0]+"/01/07 00:00"]
  }
  else {
    var ts = moment(analysis_result[0]["Datum"]).tz('Europe/Berlin').unix() 
    var new_ts = ts + 3600 * Number(analysis_result[0]["Dauer in Stunden"])
    return [analysis_result[0]["Datum"].replaceAll("-", "/"), moment.unix(new_ts).tz('Europe/Berlin').format("YYYY/MM/DD HH:mm")]
  }
}
)});
  main.variable(observer("set_zoom_history")).define("set_zoom_history", ["mutable start_date_history","moment","mutable end_date_history"], function($0,moment,$1){return(
function set_zoom_history(selection_dunkelflauten) {
  try{
  $0.value = moment.unix(moment(selection_dunkelflauten["Datum"]).tz('Europe/Berlin').unix()).tz('Europe/Berlin').format("YYYY/MM/DD HH:mm");
  $1.value = moment.unix(moment(selection_dunkelflauten["Datum"]).tz('Europe/Berlin').unix() + 3600*selection_dunkelflauten["Dauer in Stunden"]).tz('Europe/Berlin').format("YYYY/MM/DD HH:mm");}
catch(TypeError){
  console.log("No selection yet")
}
}
)});
  main.variable(observer("toggle_tab")).define("toggle_tab", function(){return(
function toggle_tab(button_id, tab_id) {
  let button = document.getElementById(button_id);
  let tab = document.getElementById(tab_id);

  if (tab.classList.contains("active") && tab.classList.contains("show")) {
    tab.classList.remove("active");
    tab.classList.remove("show");
  }
  if (button.classList.contains("active")) {
    button.classList.remove("active");
  } 
  else {
    button.classList.add("active");
    tab.classList.add("active");
    tab.classList.add("show");
  }
}
)});
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<h3 class="hidden">Event Handler</h3>`
)});
  main.variable(observer()).define(["heat_map_history","mutable start_date_history","get_date_by_year_day_full_date","mutable end_date_history"], function(heat_map_history,$0,get_date_by_year_day_full_date,$1){return(
heat_map_history.chart_backend.on('click', function (params) {
  $0.value = get_date_by_year_day_full_date(params.value[1], params.value[0]) + " 00:00";
  $1.value = get_date_by_year_day_full_date(params.value[1], params.value[0]) + " 23:00";

})
)});
  main.variable(observer()).define(["htl"], function(htl){return(
htl.html`<h2 class="hidden">Externe Bibliotheken</h2>`
)});
  main.variable(observer("_")).define("_", ["require"], function(require){return(
require('underscore')
)});
  main.variable(observer("echarts")).define("echarts", ["require"], function(require){return(
require("https://cdn.jsdelivr.net/npm/echarts@5.1.2/dist/echarts.min.js")
)});
  main.variable(observer("moment")).define("moment", ["require"], function(require){return(
require('https://momentjs.com/downloads/moment-timezone-with-data-1970-2030.js')
)});
  main.variable(observer("html")).define("html", ["htl"], function(htl){return(
htl.html
)});
  main.variable(observer()).define(["require","FileAttachment"], async function(require,FileAttachment){return(
require(await FileAttachment("bootstrap.bundle.min.js").url())
)});
  return main;
}
